import axiosInstance from "../../apiAxios/axiosInstance";

// Get all notifications
export const getNotifications = async (payload) => {
  const response = await axiosInstance.post("/admin/all-notifications", payload);
  return response.data;
};
export const getDropdownNotifications = async (payload) => {
  const response = await axiosInstance.post("/admin/notifications", payload);
  return response.data;
};

// Get unread count
export const getUnreadCount = async (payload) => {
  const response = await axiosInstance.post(
    "/admin/notifications/unread-count",
    payload
  );
  return response.data;
};

// Mark a single notification as read
export const markNotificationRead = async (payload) => {
  const response = await axiosInstance.post("/admin/notifications/mark-read",payload);
  return response.data;
};

export const markAllNotificationsRead = async (payload) => {
  const response = await axiosInstance.post(
    "/admin/notifications/mark-all-read",
    payload
  );
  return response.data;
};

// Delete a notification
export const deleteNotification = async (payload) => {
  const response = await axiosInstance.post(
    "/admin/notifications/delete",
    payload
  );
  return response.data;
};